export const NOTIFICATION_MESSAGES = {
  PREPARE_SAFE: {
    LOADING: {
      title: "Preparing SAFE Form",
      message: "Please wait while we process your request...",
    },
    SUCCESS: {
      title: "SAFE Form Prepared",
      message: "Your SAFE form has been successfully prepared.",
    },
    ERROR: {
      title: "Error",
      message: "Error generating SAFE. Please try again.",
    },
  },
  CREATE_SAFE: {
    LOADING: {
      title: "Creating SAFE",
      message: "Please wait while we generate your SAFE documents...",
    },
    SUCCESS: {
      title: "SAFE Created Successfully",
      message: "Your SAFE documents are now ready for download.",
    },
    ERROR: {
      title: "Error",
      message: "Failed to create SAFE. Please try again.",
    },
  },
  IFRAME_LOADING: {
    LOADING: {
      title: "Loading Preview",
      message: "Please wait while we convert redline for preview...",
    },
    SUCCESS: {
      title: "Preview Loaded",
      message: "The redline preview is now ready for viewing.",
    },
  },
  EMAIL_GENERATOR: {
    LOADING: {
      title: "Sending email",
      message: "Please wait while we send your email...",
    },
    SUCCESS: {
      title: "Email Received",
      message: "You have received a new email.",
    },
    ERROR: {
      title: "Error",
      message: "Failed to send email. Please try again.",
    },
  },
};
